import { Outlet, useLocation } from 'react-router-dom'
import SideBar from './SideBar'
import BoardSideMenuBar from './BoardSideMenuBar'
import {
  getClassRoomBoard,
  getClassRoomStudentBoardsGrid,
  getClassRoomInfo,
  postClassRoomOpen,
} from '../apis/classRoom.ts'
import { useEffect, useState } from 'react'
import * as StompJs from '@stomp/stompjs'
import BoardIndividualSideBar from './BoardIndividualSideBar.jsx'

function ClassLayout() {
  return (
    <div className='wrapper'>
      <SideBar />
      <div className='contents-wrapper flex items-center justify-center'>
        <div className='scroll-bar-none h-full w-[1280px] overflow-scroll'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

function WhiteBoardLayout() {
  const location = useLocation()
  const [currentPage, setCurrentPage] = useState()
  const [isSideBarFold, setIsSideBarFold] = useState(false)
  const [classroomOpen, setClassroomOpen] = useState()
  const [currentStudentNum, setCurrentStudentNum] = useState()

  /*************** WebSocket API **************/
  let [client, changeClient] = useState(null)
  // const [chat, setChat] = useState('') // 입력된 chat을 받을 변수
  const [socketEventResponse, setSocketEventResponse] = useState()
  // console.log(chatList)
  const callback = function (message) {
    if (message.body) {
      let msg = JSON.parse(message.body)
      setSocketEventResponse(msg)
    }
  }
  // console.log(chatList)
  const connect = () => {
    // 소켓 연결
    try {
      const clientData = new StompJs.Client({
        brokerURL: 'wss://api.klassmate.io/classroom',
        connectHeaders: {
          // login: '',
          Authorization: `Bearer ${classroomOpen?.classroomAccessToken}`,
          classroomId: `${classroomOpen?.id}`,
          // passcode: 'password',
        },
        debug: function (str) {
          // console.log(str)
        },
        reconnectDelay: 5000, // 자동 재 연결
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,
      })

      // 구독
      clientData.onConnect = function () {
        console.log('connected')
        clientData.subscribe(classroomOpen?.socketSubUrl, callback)
      }

      clientData.activate() // 클라이언트 활성화
      changeClient(clientData) // 클라이언트 갱신
    } catch (err) {
      console.log(err)
    }
  }
  const disConnect = () => {
    if (client === null) {
      return
    }
    client.deactivate()
  }
  useEffect(() => {
    // 최초 렌더링 시 , 웹소켓에 연결
    connect()

    return () => disConnect()
    // eslint-disable-next-line
  }, [classroomOpen])
  useEffect(() => {
    // 최초 렌더링 시 , 웹소켓에 연결
    connect()

    return () => disConnect()
    // eslint-disable-next-line
  }, [classroomOpen])
  // console.log(socketSubUrl)
  console.log(socketEventResponse)

  /*************** 수업방 정보 조회 API **************/
  const [classroomInfo, setClassroomInfo] = useState()
  const postClassRoomInfoApi = async () => {
    const postClassRoomInfoResponse = await getClassRoomInfo({
      sessionId: location.state.sessionData.id,
    })
    if (postClassRoomInfoResponse.error) {
      console.log(postClassRoomInfoResponse.message)
      return
    } else {
      setClassroomInfo(postClassRoomInfoResponse.data)
      setCurrentPage(classroomInfo?.lastViewedPage)
      // console.log(postClassRoomOpenResponse.data)
    }
  }

  /*************** 수업방 오픈 API **************/
  // const [classroomOpen, setClassroomOpen] = useState()
  const postClassRoomOpenApi = async (classroomId) => {
    const postClassRoomOpenResponse = await postClassRoomOpen({
      classroomId: classroomId,
    })
    if (postClassRoomOpenResponse.error) {
      console.log(postClassRoomOpenResponse.message)
      return
    } else {
      setClassroomOpen(postClassRoomOpenResponse.data)
      // setSocketSubUrl(postClassRoomOpenResponse.data.socketSubUrl)
      setCurrentPage(postClassRoomOpenResponse.data.lastViewedPage)
      getClassRoomStudentBoardsGridApi(postClassRoomOpenResponse.data.lastViewedPage)

      // console.log(postClassRoomOpenResponse.data)
    }
  }

  /*************** 보드 목록 조회 API **************/
  const [boardList, setBoardList] = useState([])
  const getClassRoomBoardApi = async () => {
    const getClassRoomBoardResponse = await getClassRoomBoard({ classroomId: classroomInfo?.id })
    if (getClassRoomBoardResponse.error) {
      console.log(getClassRoomBoardResponse.error)
      return
    } else {
      // console.log(getClassRoomBoardResponse.data)
      setBoardList(getClassRoomBoardResponse.data.classroomBoard)
    }
  }

  /*************** API 호출 **************/
  useEffect(() => {
    postClassRoomInfoApi()
    if (classroomInfo) {
      getClassRoomBoardApi()
    }
    // eslint-disable-next-line
  }, [classroomInfo?.id])

  /*************** 학생 보드 그리드 조회 API **************/
  useEffect(() => {
    if (boardList.length > 0) {
      getClassRoomStudentBoardsGridApi(currentPage)
    }
    // eslint-disable-next-line
  }, [currentPage])

  const [studentBoardsGridList, setStudentBoardsGridList] = useState([])
  // console.log(studentBoardsGridList)
  const getClassRoomStudentBoardsGridApi = async (currentPage) => {
    const getClassRoomStudentBoardsGridResponse = await getClassRoomStudentBoardsGrid({
      classroomBoardId: boardList?.find((item) => item.pageNum === currentPage)?.id,
    })

    if (getClassRoomStudentBoardsGridResponse.error) {
      console.log(getClassRoomStudentBoardsGridResponse)
      return
    } else {
      setStudentBoardsGridList(getClassRoomStudentBoardsGridResponse.data)
    }
  }

  const [viewType, setViewType] = useState()

  const handleViewType = () => {
    // if (classroomInfo?.status === 'COMPLETED') {
    if (viewType) {
      setViewType()
      setCurrentStudentNum()
    } else {
      setViewType('GRID')
    }
    // } else return
  }

  const [sideBarWidth, setSideBarWidth] = useState(0)
  // console.log(sideBarWidth)
  // console.log(currentPage)
  return (
    <div className='wrapper'>
      <div className='board-wrapper'>
        <Outlet
          context={{
            classroomInfo,
            boardList,
            currentPage,
            setCurrentPage,
            socketEventResponse,
            isSideBarFold,
            setIsSideBarFold,
            postClassRoomInfoApi,
            postClassRoomOpenApi,
            connect,
            studentBoardsGridList,
            currentStudentNum,
            setCurrentStudentNum,
            getClassRoomStudentBoardsGridApi,
            getClassRoomBoardApi,
            viewType,
            handleViewType,
            sideBarWidth,
          }}
        />
      </div>
      {socketEventResponse?.type.includes('GRID') || viewType === 'GRID' ? (
        <BoardIndividualSideBar
          studentBoardList={studentBoardsGridList}
          currentStudentNum={currentStudentNum}
          setCurrentStudentNum={setCurrentStudentNum}
          isSideBarFold={isSideBarFold}
          setIsSideBarFold={setIsSideBarFold}
          setSideBarWidth={setSideBarWidth}
          sideBarWidth={sideBarWidth}
        />
      ) : (
        boardList?.length > 0 && (
          <BoardSideMenuBar
            isSideBarFold={isSideBarFold}
            setIsSideBarFold={setIsSideBarFold}
            classroomInfo={classroomInfo}
            boardList={boardList}
            // studentBoardList={studentBoardsGridList}
            getApi={() => getClassRoomBoardApi()}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSideBarWidth={setSideBarWidth}
            sideBarWidth={sideBarWidth}
            // socketEventResponse={socketEventResponse}
          />
        )
      )}
    </div>
  )
}

export { ClassLayout, WhiteBoardLayout }
